import React from "react"

import { cn } from "@productlane/lib/src/cn"

interface Props {
	children: React.ReactNode
	className?: string
	"data-testid"?: string
}

function LandingCard(props: Props) {
	const { children, className, ...rest } = props

	return (
		<div
			className={cn(
				`relative h-full max-w-[800px] overflow-hidden rounded-2xl border bg-gray-50 px-7 pt-12 dark:border-gray-700 dark:bg-gray-850`,
				className,
			)}
			{...rest}
		>
			{children}
		</div>
	)
}

function LandingCardTitle({ children }: Props) {
	return (
		<div className="mb-4 text-[1.5rem] font-bold text-gray-900 sm:text-[1.9rem] dark:text-white">
			{children}
		</div>
	)
}

function LandingCardParagraph({ children, className }: Props) {
	return (
		<div className={cn(`mb-8 font-medium leading-7 text-secondary`, className)}>
			{children}
		</div>
	)
}

LandingCard.Title = LandingCardTitle
LandingCard.Paragraph = LandingCardParagraph

export { LandingCard }
